import React, { useState } from 'react'
import type { RadioChangeEvent } from 'antd'
import { Radio, Timeline } from 'antd'

const TimeLineP: React.FC = () => {
  const [mode, setMode] = useState<'left' | 'alternate' | 'right'>('left')

  const onChange = (e: RadioChangeEvent) => {
    setMode(e.target.value)
  }

  return (
    <>
      <Radio.Group
        onChange={onChange}
        value={mode}
        style={{
          marginBottom: 20,
        }}>
        <Radio value='left'>To do</Radio>
        <Radio value='right'>Review</Radio>
        <Radio value='alternate'>Done</Radio>
      </Radio.Group>
      <Timeline
        mode={mode}
        items={[
          {
            label: '2015-09-01',
            children: 'Create a services',
          },
          {
            label: '2015-09-01 09:12:11',
            children: 'Solve initial network problems',
          },
          {
            children: 'Technical testing',
          },
          {
            label: '2015-09-01 09:12:11',
            children: 'Network problems being solved',
          },
        ]}
      />
    </>
  )
}

export default TimeLineP
